// Переход мини-модуля главной на страницу полного модуля и разбор его параметров (T18).
// Контракт URL: ?key=<ключ гейта>&from=YYYY-MM-DD&to=YYYY-MM-DD&adults=N&children=M —
// имена как у /api/lengths. Без DOM — под юнит-тесты.

const ISO_RE = /^\d{4}-\d{2}-\d{2}$/;

// Строгая ISO-дата: формат и реальная дата (2026-02-30 → null)
function isoDate(raw) {
  const s = String(raw ?? "").trim();
  if (!ISO_RE.test(s)) return null;
  const t = Date.parse(`${s}T00:00:00Z`);
  if (Number.isNaN(t)) return null;
  return new Date(t).toISOString().slice(0, 10) === s ? s : null;
}

// Целое из query; дробь/мусор/пусто → null
function intParam(raw) {
  const s = String(raw ?? "").trim();
  return /^-?\d+$/.test(s) ? Number(s) : null;
}

// Параметры поиска из строки запроса страницы полного модуля. Даты обязательны и должны быть
// в будущем (заезд не раньше today, выезд позже заезда) — иначе null, модуль открывается чистым.
// Гости клампятся как в степпере: взрослые 1..cap (мусор → defaultAdults), дети 0..(cap − взрослые).
export function searchFromLocation(searchString, { today, cap = 6, defaultAdults = 2 } = {}) {
  let params;
  try {
    params = new URLSearchParams(searchString ?? "");
  } catch {
    return null;
  }
  const checkin = isoDate(params.get("from"));
  const checkout = isoDate(params.get("to"));
  if (!checkin || !checkout) return null;
  if (today && checkin < today) return null;
  if (checkout <= checkin) return null;
  const a = intParam(params.get("adults"));
  const adults = Math.max(1, Math.min(cap, a != null && a >= 1 ? a : defaultAdults));
  const c = intParam(params.get("children"));
  const children = Math.min(Math.max(0, cap - adults), Math.max(0, c ?? 0));
  return { checkin, checkout, adults, children };
}

// Адрес страницы полного модуля с параметрами поиска. page — абсолютный или относительный
// (относительный — от baseHref, адреса страницы с мини-модулем); свой query страницы (utm)
// сохраняется, key ставится только непустой.
export function bookingPageUrl(page, { key, checkin, checkout, adults, children }, baseHref) {
  const u = new URL(page, baseHref);
  const k = typeof key === "string" ? key.trim() : "";
  if (k) u.searchParams.set("key", k);
  else u.searchParams.delete("key");
  u.searchParams.set("from", checkin);
  u.searchParams.set("to", checkout);
  u.searchParams.set("adults", String(adults));
  u.searchParams.set("children", String(children ?? 0));
  return u.href;
}
